export default __webpack_public_path__ + "static/laminas_1-46c9b367401b9ca474992eae1c735773.png";